// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hb-status-badge[data-v-7b79f8bd] {\n  font-weight: var(--fw-medium);\n}\n", ""]);
// Exports
module.exports = exports;
